const SvgComponent = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 1a8 8 0 1 1 0 16A8 8 0 0 1 9 1Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 6.67c.161-.557.48-1.027.899-1.326.419-.299.912-.408 1.39-.308.48.1.914.402 1.227.853.313.452.485 1.023.484 1.613C11 9.167 8.942 10 8.942 10"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 13h.009"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgComponent